import { render, staticRenderFns } from "./VersionList.vue?vue&type=template&id=3b22cfc0"
import script from "./VersionList.vue?vue&type=script&lang=ts"
export * from "./VersionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports